import { render, staticRenderFns } from "./NewsTitlePairRenderer.vue?vue&type=template&id=0f99f509&"
import script from "./NewsTitlePairRenderer.vue?vue&type=script&lang=js&"
export * from "./NewsTitlePairRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports